import { z } from 'zod'

export const UPLOADS_BINDING_CONTRACT_VERSION = '1.0.0' as const

const jsonEnvelope = z.object({
  contract_version: z.string().min(1),
}).passthrough()

export const uploadsPreflightMetadataResponseSchema = jsonEnvelope
export const uploadsIssueUploadUrlResponseSchema = jsonEnvelope
export const uploadsUploadObjectResponseSchema = z.unknown()
export const uploadsPreflightOperationResponseSchema = jsonEnvelope
export const uploadsCompleteResponseSchema = jsonEnvelope
export const uploadsGetUrlResponseSchema = jsonEnvelope
export const uploadsDeleteResponseSchema = jsonEnvelope
export const uploadsConsumeResponseSchema = jsonEnvelope
export const uploadsDownloadResponseSchema = z.unknown()

export type UploadsPreflightMetadataResponse = z.infer<typeof uploadsPreflightMetadataResponseSchema>
export type UploadsIssueUploadUrlResponse = z.infer<typeof uploadsIssueUploadUrlResponseSchema>
export type UploadsUploadObjectResponse = z.infer<typeof uploadsUploadObjectResponseSchema>
export type UploadsPreflightOperationResponse = z.infer<typeof uploadsPreflightOperationResponseSchema>
export type UploadsCompleteResponse = z.infer<typeof uploadsCompleteResponseSchema>
export type UploadsGetUrlResponse = z.infer<typeof uploadsGetUrlResponseSchema>
export type UploadsDeleteResponse = z.infer<typeof uploadsDeleteResponseSchema>
export type UploadsConsumeResponse = z.infer<typeof uploadsConsumeResponseSchema>
export type UploadsDownloadResponse = z.infer<typeof uploadsDownloadResponseSchema>
